<template>
  <section class="home-services-section section-spacing">
    <!-- <h2 class="main-heading-1-gradient text-center">
      Why do students prefer Aliff over others?
    </h2> -->
    <h2 class="main-heading-1-gradient text-center">
      What makes Students Pick Aliff Over Others
    </h2>

    <div class="container-fluid mt-3 pt-lg-5">
      <b-container>
        <b-tabs
          v-model="tabIndex"
          pills
          card
          vertical
          justified
          class="custom-vertical-tabs align-items-center"
          nav-wrapper-class="col-12 col-lg-4"
          :active-nav-item-class="tabsActive ? 'tab-active' : ''"
          align="center"
        >
          <b-tab no-body :active="tabs[0]" class="custom-tab">
            <template #title class="custom-tab-title">
              <div>
                <!-- <h5 class="title">Search your options in ONE second</h5> -->
                <h4 class="h4 tabs-title">
                  Access to Global Education in just 2.80 Lakhs
                </h4>
                <p class="para">Powerful than Google. More accurate.</p>
              </div>
            </template>
            <div class="text-center mt-2 mt-lg-0">
              <img src="@/assets/imgs/search_univ.jpeg" class="img-fluid" />
            </div>
          </b-tab>
          <b-tab no-body :active="tabs[1]" title="Tab 3">
            <template #title>
              <div>
                <h4 class="h4 tabs-title">
                  Guaranteed Admission to Universities across 14+ Countries
                </h4>
                <!-- <h5 class="title">Apply to Universities in just 3 Clicks</h5> -->
                <p class="para lh-1">Simplified process. No Frustration.</p>
              </div>
            </template>
            <div class="text-center mt-2 mt-lg-0">
              <img
                src="@/assets/imgs/Apply to Universities in just 3 Clicks.png"
                class="img-fluid"
              />
            </div>
          </b-tab>
          <b-tab no-body :active="tabs[2]" title="Tab 2">
            <template #title>
              <div>
                <!-- <h5 class="title">Keep a track on the process</h5> -->
                <h4 class="h4 tabs-title">
                  Hasselfree Visa and Admission process
                </h4>
                <p class="para">Never miss the deadline.</p>
              </div>
            </template>
            <div class="text-center mt-2 mt-lg-0">
              <img
                src="@/assets/imgs/Keep a track on the process.png"
                class="img-fluid"
              />
            </div>
          </b-tab>
          <b-tab no-body :active="tabs[3]" title="Tab 4">
            <template #title>
              <div>
                <!-- <h5 class="title">Chat with Human, not just a Machine</h5> -->
                <h4 class="h4 tabs-title">Personalized Human and AI support</h4>
                <p class="para">Get your queries answered. Instantly.</p>
              </div>
            </template>
            <div class="text-center mt-2 mt-lg-0">
              <img src="@/assets/imgs/Chat.png" class="img-fluid" />
            </div>
          </b-tab>
        </b-tabs>
      </b-container>
    </div>
    <div class="text-center mt-4">
      <button
        @click="() => $router.push({ path: '/abroad-counselling' })"
        class="btn btn-secondary-red"
      >
        Know More
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "TechServices",

  components: {},
  data() {
    return {
      tabsActive: true,
      percentageValue: 0,
      tabIndex: 0,
      tabs: [true, false, false, false]
      // intVal: "",
    };
  },
  methods: {
    tabsTimer() {
      const r = document.querySelector(":root");
      let tabNo = 0;
      let intVal = "";
      intVal = setInterval(() => {
        if (this.percentageValue < 100) {
          this.percentageValue += 1;
          // r.style.setProperty("--percentage", this.percentageValue + "%");
        } else {
          this.percentageValue = 0;
          // console.log(tabNo);
          this.$set(this.tabs, tabNo, false);
          this.$set(this.tabs, (tabNo + 1) % 4, true);

          if (tabNo == 3) {
            tabNo = 0;
            this.$set(this.tabs, tabNo, true);
          } else {
            tabNo = tabNo + 1;
          }

          // console.log(this.tabs, tabNo);

          if (this.$route.name != "home") {
            clearInterval(this.intVal);
          }
          // intVal();
        }
      }, 50);
    }
  },
  beforeMount() {
    if (this.$route.name == "home") {
      this.tabsTimer();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/partials/TechServices.vue